import { AHIcon, AHText, Circle, useLayoutContext } from "arkh";
import React, { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { PopoverList, PopoverListItem } from "./Popover";
import { TVDashboardPickerPopoverDashboards$key } from "./__generated__/TVDashboardPickerPopoverDashboards.graphql";
import { TVDashboardPickerPopoverItem_dashboard$key } from "./__generated__/TVDashboardPickerPopoverItem_dashboard.graphql";

function StorecastPickerItem(props: {
  onClose(): void;
  isCurrentDashboard: boolean;
  dashboard: TVDashboardPickerPopoverItem_dashboard$key;
  onPress(item: { id: string }): void;
}) {
  const dashboard = useFragment(
    graphql`
      fragment TVDashboardPickerPopoverItem_dashboard on Dashboard {
        id
        name
      }
    `,
    props.dashboard
  );
  const onPress = useCallback(() => {
    props.onPress({ id: dashboard.id });
    props.onClose();
  }, [dashboard.id, props]);
  return (
    <PopoverListItem selected={props.isCurrentDashboard} onPress={onPress}>
      <Circle color="surface-backgroundControl" size="smallMedium">
        <AHIcon type="dashboard" color="text-primary" size="small" />
      </Circle>
      <AHText type="title-small" spaceLeft="small" style={{ flex: 1 }}>
        {dashboard.name}
      </AHText>
    </PopoverListItem>
  );
}

function keyExtractor(item: { id: string }) {
  return item.id;
}

export function TVDashboardPickerPopover(props: {
  onClose(): void;
  dashboards: TVDashboardPickerPopoverDashboards$key;
  currentDashboardId?: string;
  onSelectItem(item: { id: string }): void;
}) {
  const dashboards = useFragment(
    graphql`
      fragment TVDashboardPickerPopoverDashboards on Dashboard
      @relay(plural: true) {
        id
        ...TVDashboardPickerPopoverItem_dashboard
      }
    `,
    props.dashboards
  );

  const layout = useLayoutContext();

  const renderItem = useCallback(
    ({ item }: { item: (typeof dashboards)[number] }) => (
      <StorecastPickerItem
        isCurrentDashboard={props.currentDashboardId === item.id}
        dashboard={item}
        onPress={props.onSelectItem}
        onClose={props.onClose}
      />
    ),
    [props.onClose, props.onSelectItem, props.currentDashboardId]
  );

  return (
    <PopoverList
      data={dashboards}
      scrollIndicatorInsets={{
        top: layout.space.medium,
        bottom: layout.space.medium,
      }}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
    />
  );
}
